import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab'];

  select(event) {
    this.tabTargets.forEach((tab) => {
      const selected = tab === event.currentTarget;
      tab.setAttribute('aria-selected', selected);
      document.getElementById(tab.getAttribute('aria-controls'))?.classList.toggle('hidden', !selected);
    });
  }
}
